import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow
} from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import { useTenants } from '@/data/tenant';

import TenantRow from './TenantRow';
import NotFound from '@/components/common/NotFound';

const TenantList = () => {
  const tenants = useTenants();

  if (tenants.data.length === 0) {
    return <NotFound title="No Tenants Found" />;
  }
  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Created</TableHead>
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {tenants.data.map((tenant) => (
              <TenantRow key={tenant.id} tenant={tenant} />
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {tenants.data.length}
        </span>
      </div>
    </>
  );
};

export default TenantList;
